import React from 'react'

const ListItem = function ListItem(props) {
    return (
        <div className={'listitem'} style={props.style}  onClick={(ev)=>{ev.stopPropagation();if (props.onClick) props.onClick()}}>{props.children}</div>
    )
}

export { ListItem };
